<div class="row justify-content-center">
    <div class="col-12 text-center">
        <h2 class="card-title section-title">Offices <span class="wow"></span></h2>
    </div>
    <div class="col-xl-10 col-lg-12">
        <div class="row justify-content-between">
            <div class="col-md-6 col-lg-5">
                <div class="location-box">
                    <div class="location-header">
                        <h6><img src="assets/images/help-center/placeholder.svg" alt="" width="12">Registered Office
                        </h6>
                    </div>
                    <div class="location-body">
                        <div>
                            <h6>Bajaj Capital Ltd</h6>
                            <p>Mezzanine Floor, 97, Bajaj House, Nehru Place, New Delhi - 110019, India</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="row">
            <div class="col-sm-6 col-md-6 col-lg-5">
                <div class="location-box">
                    <div class="location-header">
                        <h6><img src="assets/images/help-center/placeholder.svg" alt="" width="12">Northern Region</h6>
                    </div>
                    <div class="location-body">
                        <div>
                            <h6>Bajaj Capital Ltd</h6>
                            <p>Bajaj House, 97, Nehru Place, New Delhi - 110019</p>
                        </div>
                        <ul>
                            <li><img src="assets/images/help-center/phone.svg" alt="" width="9"> Call Centre : <a
                                    href="tel: 7678-123-123">7678-123-123</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-md-6 col-lg-5">

                <div class="location-box">
                    <div class="location-header">
                        <h5><img src="assets/images/help-center/placeholder.svg" alt="" width="12">Westtern Region:</h5>
                    </div>
                    <div class="location-body">
                        <div>
                            <h5>Bajaj Capital Ltd.</h5>
                            <p>Unit no-941, Bldg-9,4th Floor, Solitaire Corporate Park, Andheri Kurla Road, Chakala,
                                Andheri(E), Mumbai - 400093</p>
                        </div>
                        <ul>
                            <li><img src="assets/images/help-center/phone.svg" alt="" width="9"> Call Centre : <a
                                    href="tel:1800313123123">313-123-123</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-md-6 col-lg-5">
                <div class="location-box">
                    <div class="location-header">
                        <h5><img src="assets/images/help-center/placeholder.svg" alt="" width="12">Eastern Region:</h5>
                    </div>
                    <div class="location-body">
                        <div>
                            <h5>Bajaj Capital Ltd.</h5>
                            <p>Bajaj House, 97, Nehru Place, New Delhi - 110019</p>
                        </div>
                        <ul>
                            <li><img src="assets/images/help-center/phone.svg" alt="" width="9"> Call Centre : <a
                                    href="tel:1800313123123">1800-313-123-123</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-md-6 col-lg-5">
                <div class="location-box">
                    <div class="location-header">
                        <h5><img src="assets/images/help-center/placeholder.svg" alt="" width="12">Eastern Region:</h5>
                    </div>
                    <div class="location-body">
                        <div>
                            <h5>Bajaj Capital Ltd.</h5>
                            <p>Corporate Office (South), 3rd floor, 5-7/1, Industrial Estate, Guindy, chennai - 600032
                            </p>
                        </div>
                        <ul>
                            <li><img src="assets/images/help-center/phone.svg" alt="" width="9"> Call Centre : <a
                                    href="tel:1800313123123">1800-313-123-123</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>